export default (min, max, value) => Math.max(Math.min(value, max), min);
